import type { DeepPartial } from '@luna/utils-ts';

import type { Print } from '../../types/Print';

export const printROFeatureConfig: DeepPartial<Print> = {
    columns: {
        hideCapitalGainTax: true,
        hideTotalProfitAndFee: true,
    },
};
